import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { title } from "../utils/style";
import { formatDate } from "../helperFunctions/estimateCalculation"
import formatNumberToUs from "../custom_functions/formatNumberToUs";

function FleetStatements() {

    const options = [
        {
            header: "Statement Id",
            key: "id",
            width: "20%",
            render: (data) => { return `${data.id}` },
        },
        {
            header: 'Customer',
            key: "customer",
            render: (data) => { return data.fleet_customer.name || "" },
            width: "20%",
        },
        {
            header: 'Status',
            key: 'status',
            width: "15%",
        },
        {
            header: 'Cost',
            key: 'cost',
            render: (data) => { return data.cost === 0 ? "$0.00" : `$${formatNumberToUs(data.cost / 100)}` },
            width: "20%",
        },
        {
            header: 'Created At',
            key: 'date',
            isDateFilter: true,
            placeHolder: 'mm-dd-yyyy',
            render: (data) => { return formatDate(data.date) },
            width: "25%",
        },
    ]

    const excludeFilter = ["Cost"]



    return (
        <div className="overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Fleet Payments</div>
            </div>
            <Table
                className="max-h-[80vh] overflow-y-auto"
                options={options}
                url={url + '/fleet_invoice_statements'}
                pagination
                noButton={true}
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default FleetStatements;